<template>
  <b-navbar type="dark" class="w-nav">
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <RightNavItems />
      </b-navbar-nav>
      <b-navbar-nav class="mr-auto">
        <LeftNavItams />
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import RightNavItems from "./RightNavItems/RightNavItems";
import LeftNavItams from "./LeftNavItams/LeftNavItams";
export default {
  name: "Navbar",
  components: {
    LeftNavItams,
    RightNavItems
  }
};
</script>

<style lang="scss">
.w-nav {
  width: calc(100% - 240px);

  @media (max-width: 991px) {
    width: 100%;
  }

  #wrapper.enlarged & {
    width: calc(100% - 70px);
  }
}
.waves-effect {
  position: relative;
  cursor: pointer;
  display: flex !important;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  z-index: 1;
  will-change: opacity, transform;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
</style>
